import * as React from "react";
import * as ReactDOM from "react-dom";
import "styled-components/macro";
import SubmitButton from "../submit-button";
import RefreshButton from "../refresh-button";
import FeedbackButton from "../feedback-button";
import Feedback from "../feedback";
import VerifyImage from "../verify-image";
import VerifyImageCircle from "../verify-image-circle";
import VerifyVoice from "../verify-voice";
// 解决 css props的类型问题 见 https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31245#issuecomment-463640878
import * as types from "styled-components/cssprop"; // eslint-disable-line
import { css, withTheme } from "styled-components";
import SlideButton from "../slide-button";
// import * as models from '../../models';
import * as models from "../../models/collect";
import { RematchRootState, RematchDispatch } from "@rematch/core";
import { connect } from "react-redux";
import * as logger from "../../utils/logger";
import {
  isNative,
  isMobile,
  HORIZON_SCALE,
  HORIZON,
  VERTICAL,
  envRegion,
} from "../../utils/constants";
import VerifyBar from "../verify-bar";
import Collect from "./collect";
import { DraggableData } from "react-draggable";
import MobileButton from "../mobile-button";
import {
  listenGoToClose,
  listenVerifyReport,
  dialogSize,
  pageEndHandle,
  listenORIChange,
  getNativeTouch,
} from "../../service/jsbridge";
import { Context } from "../../i18n";
import { CaptchaWrapper } from "./style";
import {
  getRect,
  optionsSort,
  errorStack,
  getQueryParams,
  pageSlideHandler,
  getFp,
  getTeaCommonParams,
  getElementRect,
  setAppFontMotion,
  removeAppFontMotion,
  getVerifyImgWidth,
  getOrientation,
  isRTL,
  sleep,
  sortMapByTime,
} from "../../utils/utils";
import { formatPointsRate } from "@/utils/jsvmp-utils";
import { setBaseFontSize, baseRem, realBaseRem, getBaseRem } from "@/utils/rem";
import * as slardar from "../../utils/lib/slardar";
import device from "../../utils/device";
import singleText from "@/utils/single-text";
import { clearCallBack } from "@/utils/callBack";
const os_type = isMobile ? 3 : 2; // 系统平台，android:0, ios:1, web:2, h5:3

const defaultProps = {
  autoClose: true,
  ele: "verify_container",
  host: "", //主机
  lang: envRegion === "cn" ? "zh" : "en", //语言
  app_name: "", //app名称 非必须
  ch: "web_text", // 渠道 非必须
  os_type: os_type,
  h5_sdk_version: "",
  sdk_version: "",
  themeColor: "primary", // 主题类型 gry white red primary
  type: "text" as "text" | "3d" | "slide" | "whirl" | "icon" | "voice", // 用户先配置一个吧
  width: isMobile ? 276 : 340, // 图片长度
  dragWidth: isMobile ? 220 : 271, // 滑块可拖动最大长度, 276 - 52 - 2 * 2 = 220 左右各有 2px
  enter_time: Date.now(),
  orientation: 2,
};
const loggerCloseType = {
  h5_click_close: 2,
  mask_click_close: 4, ///< 验证中断，用户点击蒙层
  back_close: 5, ///< 验证中断，用户点击返回按钮（只有安卓有）
  app_close: 6, ///< 验证中断，业务方主动关闭了验证页面
  feedback_close: 7, ///< 验证中断，业务方主动关闭了验证页面
  override_close: 998, ///< 验证冲突，当前有弹出的验证窗口
};

type LoggerCloseType = keyof typeof loggerCloseType;

const mapState = ({ captcha }: RematchRootState<typeof models>) => {
  return {
    ...captcha,
  };
};
const mapDispatch = ({ captcha }: RematchDispatch<typeof models>) => {
  return {
    ...captcha,
  };
};

function moveHandler(e: Event) {
  e.preventDefault();
}

type CaptchProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch> &
  typeof defaultProps & {
    theme: any;
    sideSlide?: string;
    hideCloseBtn?: boolean;
    useCaptureStyle?: boolean;
  } & {
    aid: number;
    did: string;
    iid: string;
    verify_data?: any;
    resize: () => void;
    baseEM?: number;
    viewport?: boolean;
    feedbackEle?: string;
  };
interface CaptchaData {
  // 滑块左侧距滑动槽的距离
  drag_track: ({
    relative_time: number;
  } & Point)[];
  // 手指距滑动槽最左上侧的坐标位置
  slide_btn_track: ({
    // 滑块的运动轨迹 --- slide
    time: number;
  } & Point)[];
  mouse_tack2: ({
    time: number;
  } & Point)[];
  init_toast: {
    w: number;
    h: number;
    baseRem: number;
  };
}

class Captcha extends React.Component<
  CaptchProps,
  {
    show: boolean;
    drag_type: "none" | "img" | "btn"; // 滑块类型时拖动图片img或拖动按钮btn
  }
> {
  count = 0;
  drag_start_time = 0;
  myRef: any;
  location: any = {};
  isIntLoaded: boolean = false; // 解决点选验证码英文标题文案换行时，验证码高度应为328，实际展示过低的问题
  open_time = Date.now();
  static defaultProps = defaultProps;
  static contextType = Context;
  context!: React.ContextType<typeof Context>;
  enterLogTime: number = 0;
  data: CaptchaData = {
    // 滑动轨迹
    drag_track: [],
    // 滑块滑动位置，日志所需
    slide_btn_track: [],
    mouse_tack2: [],
    init_toast: {
      w: 0,
      h: 0,
      baseRem: 0,
    },
  };
  constructor(props: any) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      show: true,
      drag_type: "none",
    };
    logger.trackEvent("init", {
      stage: "startRenderCaptchaBefore",
    });
  }
  afterRefresh = (callback?: () => void, first?: boolean) => {
    if (isNative && !this.isIntLoaded) {
      singleText.getText().then(() => {
        // 文案获取结束，排版渲染完后再调整弹窗
        this.isIntLoaded = true;
        this.dialogSize();
        const rect = getElementRect(this.myRef);
        this.data.init_toast = {
          w: rect.w,
          h: rect.h,
          baseRem: getBaseRem(),
        };
      });
    }
    if (typeof callback === "function") {
      callback();
    }
  };
  refresh = (callback?: () => void, first?: boolean) => {
    // slide_btn_track手指距滑动槽最左上侧的坐标位置
    // drag_track 滑块左侧距滑动槽的距离
    const { slide_btn_track, mouse_tack2 } = this.data;
    slide_btn_track.length = 0;
    mouse_tack2.length = 0;

    this.data.drag_track = [];
    const { challenge_code, keepRootDivPos, type } = this.props;
    const rect = getRect(this.myRef);
    // 保存根元素位置
    keepRootDivPos({
      left: rect.left,
      top: rect.top,
    });
    if (type === "voice") {
      this.props
        .refresh4Voice({
          query: getQueryParams(this.props),
          first,
        })
        .then(() => {
          this.afterRefresh(callback);
        });
    } else {
      this.props
        .refresh({
          query: getQueryParams(this.props),
          challenge_code,
          text: {
            net_error: this.context.net_error,
            loading: this.context.loading,
          },
        })
        .then(() => {
          this.afterRefresh(callback);
        });
    }
  };
  dialogSize = () => {
    const myRef = this.myRef;
    if (myRef) {
      setTimeout(() => {
        // 放到下一个事件里，保证渲染事件已完成，获取更精准的范围
        const rect = getElementRect(myRef);
        dialogSize(rect);
      });
    }
  };
  componentWillReceiveProps = (nextProps: any) => {
    if (
      isNative &&
      this.props.challenge_id !== nextProps.challenge_id &&
      this.isIntLoaded
    ) {
      // JSBridge --- 通知尺寸
      this.dialogSize();
    }
  };
  componentDidMount() {
    // 解决H5单页页面穿透导致页面可侧滑的问题
    const { sideSlide, useCaptureStyle } = this.props;

    // 通用的禁止业务方页面滑动处理
    pageSlideHandler.init(useCaptureStyle);
    pageSlideHandler.disabled();

    if (sideSlide === "disabled") {
      // 头条主端会监听console.log，如果输出bytedance://disable_swipe，那么会禁止滑动
      console.log("bytedance://disable_swipe"); // eslint-disable-line
    }
    // 是否为端内
    if (isNative) {
      this.appHandler();
    }
    logger.trackEvent("init", {
      stage: "startRenderCaptcha",
    });
    this.refresh(() => {
      logger.trackEvent("init", {
        stage: "startRenderCaptchaDone",
      });
    }, true);
    if (isNative) {
      this.listenORI();
    }
    if (isMobile) {
      device.mount();
    }
  }

  componentWillMount() {
    if (isMobile) {
      device.unmount();
    }
  }

  listenORI() {
    let lastOrientation = getOrientation();
    listenORIChange<{
      orientation: number;
    }>(({ orientation }) => {
      const init_toast = this.data.init_toast;
      const { type, resize } = this.props;
      if (orientation !== lastOrientation && this.state.show) {
        window.captchaOptions.orientation = orientation;
        lastOrientation = orientation;
        const baseRem = getBaseRem();
        const rect = {
          w: init_toast.w * (baseRem / init_toast.baseRem),
          h: init_toast.h * (baseRem / init_toast.baseRem),
        };
        dialogSize(rect);
        removeAppFontMotion();
        resize();
        setAppFontMotion();
        const { selected_pos } = this.props;
        const pos = selected_pos.map((item: any) => {
          if (orientation === HORIZON) {
            return {
              ...item,
              x: item.x * HORIZON_SCALE,
              y: item.y * HORIZON_SCALE,
            };
          } else {
            return {
              ...item,
              x: item.x / HORIZON_SCALE,
              y: item.y / HORIZON_SCALE,
            };
          }
        });
        this.props.update({
          selected_pos: pos,
        });
      }
    });
  }
  // native端处理
  appHandler() {
    // const { challenge_id, challenge_mode, challenge_code } = this.props;
    // jsbridge --- 监听点击蒙版的关闭
    listenGoToClose().then((res: any) => {
      const closeType: LoggerCloseType =
        (res && res.style) || "mask_click_close";
      this.pageEndHandle(closeType);
    });
    // jsbridge --- SDK每次采集满200个事件主动给FE发送，监听该事件
    // 在发送的时候，如果本地也有失败事件，顺便把本地的事件合并进去一起发送
    listenVerifyReport().then((res: any) => {
      if (res && res.data instanceof Array) {
        logger.batchSendEvents(res.data.concat(window.captchaFailEvents));
      }
    });
  }
  pageEndHandle(closeType: LoggerCloseType) {
    const { challenge_id, challenge_mode, challenge_code } = this.props;
    pageEndHandle({
      challenge_id,
      challenge_mode,
      challenge_code,
      verifyResultType: loggerCloseType[closeType],
      closeType,
      duration: Date.now() - this.open_time,
    });
  }
  handleRefresh = () => {
    const { refresh_btn_able } = this.props;
    if (!refresh_btn_able) {
      return;
    }

    // 刷新素材
    this.props.refreshIncrease();
    const { challenge_id, challenge_mode, challenge_code, refresh_frequency } =
      this.props;
    logger.trackEvent("action_refresh", {
      mode: challenge_mode,
      challenge_id,
      challenge_code,
      times: refresh_frequency + 1, // 手动加一，refresh_frequency 为旧值
    });
    this.refresh();
  };
  /**
   * 关闭验证码
   */
  handleClose = (closeType: LoggerCloseType = "h5_click_close") => {
    // 日志 --- 关闭弹窗
    const {
      challenge_id,
      challenge_mode,
      challenge_code,
      sideSlide,
      autoClose,
    } = this.props;

    this.props.hide();

    if (sideSlide === "disabled") {
      // 关闭验证码之后，恢复enable_swipe
      console.log("bytedance://enable_swipe"); // eslint-disable-line
    }
    const isFeedbackNotAutoClose =
      autoClose === false && closeType === "feedback_close";

    // 设置autoClose为false时，反馈提交关闭走feedbackSubmitCb回调。
    if (isFeedbackNotAutoClose) {
      if (typeof window.captchaOptions.feedbackSubmitCb === "function") {
        window.captchaOptions.feedbackSubmitCb();
      }
    } else {
      if (typeof window.captchaOptions.closeCb === "function") {
        window.captchaOptions.closeCb();
      }
    }

    // 使用 JSBridge
    if (isNative) {
      this.pageEndHandle(closeType);
    } else {
      logger.trackEvent("close", {
        mode: challenge_mode,
        challenge_id,
        challenge_code,
        style: closeType,
        duration: Date.now() - this.open_time,
      });
    }

    clearCallBack();
    slardar.close();
  };
  /**
   * 处理已选点的点击逻辑
   */
  handlePointClick = (idx: number) => {
    this.props.removePos(idx);
  };
  /**
   * 滑动开始
   */
  handleSlideStart = (
    e: any,
    data: DraggableData,
    drag_type: "none" | "img" | "btn"
  ) => {
    e.preventDefault();
    this.setState({ drag_type });
    // 头条主端会监听console.log，如果输出bytedance://disable_swipe，那么会禁止滑动
    if (isMobile) console.log("bytedance://disable_swipe"); // eslint-disable-line
    this.props.slidingToggle(true);
    this.drag_start_time = Date.now();
    this.data.drag_track = [];
    this.props.update({
      feedback_btn_able: false,
    });
  };
  /**
   * 滑动中
   */
  handleDrag = (e: any, data: DraggableData) => {
    const { drag_track, slide_btn_track } = this.data;
    const {
      updateDragPos,
      drag_pos,
      rootDivLeft,
      rootDivTop,
      trackSlide,
      init_time,
      challenge_id,
      trackMouseMove,
    } = this.props;

    const time = Date.now();
    const relative_time = time - this.drag_start_time;
    const clientX =
      typeof e.clientX !== "undefined" ? e.clientX : e.touches?.[0].clientX;
    const clientY =
      typeof e.clientY !== "undefined" ? e.clientY : e.touches?.[0].clientY;
    const x = clientX - rootDivLeft;
    const y = clientY - rootDivTop;
    const teaCommonParams = logger.getParams();
    // 添加埋点，验证是否会存在 this.drag_start_time = 0 的情况
    if (!this.drag_start_time) {
      logger.trackEvent("start_time_0", {
        ...teaCommonParams,
        start_time: this.drag_start_time,
        challenge_id,
      });
    }

    trackSlide({
      x: Number(clientX?.toFixed(0)),
      y: Number(clientY?.toFixed(0)),
      t: time - init_time,
    });
    trackMouseMove({
      x: Number(clientX?.toFixed(0)),
      y: Number(clientY?.toFixed(0)),
      time: time - init_time,
      target: e?.target?.tagName,
    });

    updateDragPos({
      x: data.x,
    });

    // 保存滑块轨迹和触摸轨迹
    drag_track.push({
      x: data.x,
      y: drag_pos.y,
      relative_time,
    });
    slide_btn_track.push({
      x: Number(x.toFixed(3)),
      y: Number(y.toFixed(3)),
      time,
    });
  };
  handleSubmit4Voice = async (answer: string) => {
    if (!answer) return;
    const { challenge_id, mode } = this.props;
    const data = {
      id: challenge_id,
      mode,
      reply: [
        {
          answer,
        },
      ],
    };
    await this.props.submit4Voice({
      query: getQueryParams(this.props),
      data: data,
      duration: Date.now() - this.open_time,
    });
  };
  /**
   * 滑动结束 以及 点击确认按钮
   */
  handleSubmit = async () => {
    const { type, confirm_btn_able } = this.props;
    if (type === "3d" || type === "text" || type === "icon") {
      if (!confirm_btn_able) {
        return; // 确认按钮禁止点击
      }
    }
    const { drag_track, slide_btn_track, mouse_tack2 } = this.data;
    // 对 drag_track 进行 sort 保证点的顺序都是按照时间顺序给到服务端的（数据侧有发现过部分点的顺序异常的情况，不确定是黑产还是代码异常情况）
    sortMapByTime(drag_track, "relative_time");
    const {
      challenge_code,
      enter_verify_dialog_msg, // 最后一次进入滑块范围的位置
      enter_slide_bar_msg, // 最后一次进入验证框的位置
      mouse_track,
      autoClose,
      width,
      selected_pos,
      challenge_id,
      challenge_mode,
      clickSubmitIncrease,
      drag_pos,
      sideSlide,
      rootDivLeft,
      rootDivTop,
    } = this.props;
    // 提前显示loading，下面的代码涉及GPU计算，可能会阻涉造成卡顿
    this.props.update({
      point_add_able: false,
      confirm_btn_able: false,
      slide_btn_able: false,
      refresh_btn_able: false,
      show_verify_msg: true,
      loading: true,
      verify_result_msg: "",
    });

    let modifiedImgWidth = (width * baseRem) / 100;
    try {
      if (type !== "whirl") {
        const idealImgWidth = modifiedImgWidth;
        const realImgWidth = getVerifyImgWidth(this.myRef);
        if (realImgWidth !== -1) {
          modifiedImgWidth = realImgWidth;
        }
      }
    } catch (error) {}

    let dragWidth =
      type === "whirl"
        ? (defaultProps.dragWidth * baseRem) / 100
        : defaultProps.dragWidth;
    const reply =
      type === "slide" || type === "whirl"
        ? drag_track
        : selected_pos.map((item: Point) => ({ x: item.x, y: item.y }));
    const now = Date.now();
    this.props.setDragWidth(dragWidth);
    this.props.setModifiedImgWidth(modifiedImgWidth);
    this.props.setPostTime(now);
    this.props.setUgt(now - this.props.init_time);
    this.props.setReply(reply);
    await this.props.submit({
      query: getQueryParams(this.props),
      data: {},
      text: {
        net_error: this.context.net_error,
        loading: this.context.loading,
      },
      autoClose,
      challenge_code,
      duration: Date.now() - this.open_time,
      sideSlide,
      drag_type: this.state.drag_type,
    });
  };
  /**
   * 日志 --- 记录最后一次进入验证码区域
   */
  handlerEnterLog = (evt: any) => {
    const { keepEnterVerifyDialogMsg, setMouseTrack } = this.props;
    setMouseTrack([]);
    const time = Date.now();
    this.enterLogTime = time;
    const x = evt.clientX - this.props.rootDivLeft;
    const y = evt.clientY - this.props.rootDivTop;
    keepEnterVerifyDialogMsg({
      time,
      x,
      y,
    });
  };
  /**
   * 日志 --- 记录最后一次进入滑动区域的信息
   */
  handleEnterSlideBar = (evt: any) => {
    const { keepeEnterSlideBarMsg } = this.props;
    const time = Date.now();
    const x = evt.clientX - this.props.rootDivLeft;
    const y = evt.clientY - this.props.rootDivTop;
    keepeEnterSlideBarMsg({
      x,
      y,
      time,
    });
  };
  /**
   * 日志 --- 记录验证码图片区域鼠标滑动轨迹
   */
  mouseMoveHandler = (evt: any) => {
    // if (this.props.type === 'slide') {
    //   return;
    // }
    const x = evt.clientX - this.props.rootDivLeft;
    const y = evt.clientY - this.props.rootDivTop;
    this.data.mouse_tack2.push({
      x,
      y,
      time: Date.now(),
    });
    this.count++;
    if (this.count % 5 !== 0) {
      // 每隔5次进行记录
      return;
    }
    const { trackIncrease } = this.props;
    trackIncrease({
      x,
      y,
      // relative_time: Date.now() - this.enterLogTime
      time: Date.now(), // 暂定为绝对时间
    });
  };
  // 反馈模块
  renderFeedback = (isWhirl: boolean) => {
    const { viewport, baseEM } = this.props;
    if (!this.props.feedback_btn_able) {
      // 验证码滑动过程中禁掉反馈按钮，否则在滑动过程中打开反馈会出现弹窗过窄的情况
      return;
    }
    const { theme, challenge_code, challenge_mode, challenge_id, feedbackEle } =
      this.props;
    const orientation = getOrientation();
    const { feedback_text } = this.context;
    this.props.hide();
    const root =
      (feedbackEle && document.getElementById(feedbackEle)) ||
      document.body ||
      document.documentElement;
    const wrapper = document.createElement("div");
    root.appendChild(wrapper);
    const resize = setBaseFontSize(wrapper, viewport, baseEM);
    const onDestroy = () => {
      ReactDOM.unmountComponentAtNode(wrapper);
      root.removeChild(wrapper);
    };
    const onClose = () => {
      onDestroy();
      // 解决1128业务H5单页页面穿透导致页面可侧滑的问题
      pageSlideHandler.disabled();
      this.props.show();
      if (isNative) {
        setTimeout(() => {
          this.dialogSize();
        });
        setTimeout(() => {
          this.setState({
            show: true,
          });
        }, 300);
        this.setState({
          show: false,
        });
      }
    };
    const onSubmit = (value: string) => {
      logger.trackEvent("feedback", {
        mode: challenge_mode,
        region: window.captchaOptions.region,
        option: value,
        challenge_code,
        challenge_id,
        errorStack: JSON.stringify(errorStack.data),
        finalStage: errorStack.finalStage,
        online: String(window.navigator.onLine),
      });
      if (!isMobile) {
        onDestroy();
        this.handleClose("feedback_close");
      }
    };
    const onSuccess = () => {
      pageSlideHandler.allow();
      onDestroy();
      this.handleClose("feedback_close");
    };
    feedback_text.options = optionsSort(feedback_text.options);
    ReactDOM.render(
      <Feedback
        orientation={orientation}
        text={feedback_text}
        theme={theme}
        onClose={onClose}
        onSubmit={onSubmit}
        onSuccess={onSuccess}
        resize={resize}
        isWhirl={isWhirl}
      />,
      wrapper
    );
  };
  // PC端按钮UI
  renderWebButton = () => {
    const { type, confirm_btn_able, challenge_code } = this.props;
    const isBtnShape =
      !type &&
      (challenge_code == 3059 ||
        challenge_code == 3060 ||
        challenge_code == 99995);
    if (
      (type === "text" || type === "3d" || type === "icon" || isBtnShape) &&
      !isMobile
    )
      return (
        <SubmitButton
          onSubmit={this.handleSubmit}
          confirmBtnAble={confirm_btn_able}
        />
      );
    else return null;
  };
  // 移动端按钮UI
  renderMobileButton = () => {
    const { type, confirm_btn_able, theme, challenge_code } = this.props;
    const isBtnShape =
      !type &&
      (challenge_code == 3059 ||
        challenge_code == 3060 ||
        challenge_code == 99995);
    const { confirm } = this.context;
    if (
      (type === "text" || type === "3d" || type === "icon" || isBtnShape) &&
      isMobile
    )
      return (
        <MobileButton
          className="verify-captcha-submit-button"
          text={confirm}
          onClick={this.handleSubmit}
          disabled={!confirm_btn_able}
          color={theme.sureBtnFontColor}
          bgColor={theme.sureBtnBgColor}
          opacity={theme.sureBtnBgOpacity}
        />
      );
    else return null;
  };
  closeFeedback = () => {};
  render() {
    const {
      isOpen,
      answer_url,
      question_url,
      loading,
      selected_pos,
      verify_status,
      for_3d_bar_text,
      sliding,
      slide_btn_able,
      hideCloseBtn,
      theme,
      drag_pos,
      type,
      show_verify_msg,
      lang,
      challenge_code,
    } = this.props;
    const ele = document.getElementById(window.captchaOptions.ele);
    if (!isOpen) {
      if (ele) {
        if (document.body.classList && document.body.classList.remove)
          document.body.classList.remove("captcha-disable-scroll");
        ele.style.display = "none";
      }
      pageSlideHandler.allow();
      return null;
    } else {
      if (ele) {
        ele.style.display = "block";
      }
    }
    const isMask = window.captchaOptions.showMode === "mask";
    //eslint-disable-next-line
    const isWhirl = type === "whirl" || (!type && challenge_code == 99996); // 在莫种情况下 challenge_code 值是字符串
    const isSlide = type === "slide" || (!type && challenge_code == 3058);
    const isVoice = type === "voice";

    return (
      <CaptchaWrapper
        role="dialog"
        theme={theme}
        isMobile={isMobile}
        isVoice={isVoice}
        isMask={isMask}
        isRTL={isRTL(lang)}
        className="captcha_verify_container"
        onMouseEnter={this.handlerEnterLog}
        onMouseMove={this.mouseMoveHandler}
        ref={(node) => (this.myRef = node)}
        style={{ visibility: this.state.show ? "visible" : "hidden" }}
      >
        {!isVoice && (
          <VerifyBar
            // 验证码顶部栏
            hideCloseBtn={hideCloseBtn}
            type={type}
            handleClose={() => this.handleClose()}
            answer_url={answer_url}
            for_3d_bar_text={for_3d_bar_text}
            lang={lang}
          />
        )}
        {/* 语音验证码 */}
        {isVoice && (
          <VerifyVoice
            hideCloseBtn={hideCloseBtn}
            handleClose={() => this.handleClose()}
            lang={lang}
            show={this.state.show}
            img_error_text={this.context.img_error}
            onMouseMove={this.mouseMoveHandler}
            handleSubmit4Voice={this.handleSubmit4Voice}
            refresh={this.refresh}
          />
        )}
        {/* 双环验证码图片 */}
        {isWhirl && (
          <VerifyImageCircle
            lang={lang}
            show={this.state.show}
            img_error_text={this.context.img_error}
            onMouseMove={this.mouseMoveHandler}
          />
        )}
        {!isWhirl && !isVoice && (
          <>
            <Collect />
            <VerifyImage
              // 验证码背景图片和答案
              drag_type={this.state.drag_type}
              drag_pos={drag_pos}
              sliding={sliding}
              slide_btn_able={slide_btn_able}
              onSubmit={this.handleSubmit}
              onStart={this.handleSlideStart}
              onDrag={this.handleDrag}
              imgLoadingBgColor={theme.imgLoadingBgColor}
              selected_pos={selected_pos}
              question_url={question_url}
              verify_status={verify_status}
              loading={loading}
              img_error_text={this.context.img_error}
              onMouseMove={this.mouseMoveHandler}
            />
          </>
        )}
        {(isSlide || isWhirl) && (
          <SlideButton
            // 滑块可拖动区域
            lang={lang}
            verify_status={verify_status}
            show_verify_msg={show_verify_msg}
            drag_type={this.state.drag_type}
            drag_pos={drag_pos}
            sliding={sliding}
            slide_btn_able={slide_btn_able}
            isWhirl={isWhirl}
            onEnterSlide={this.handleEnterSlideBar}
            onSubmit={this.handleSubmit}
            onStart={this.handleSlideStart}
            onDrag={this.handleDrag}
          />
        )}
        {!isVoice && (
          <div
            // 验证码底部区域
            className="captcha_verify_action"
            css={css`
              padding: 0.08em 0.12em 0.12em;
              display: flex;
              justify-content: space-between;
              align-items: center;
              line-height: 0.2em;
              min-height: 0.2em;
              color: #505050;
            `}
          >
            <div
              css={css`
                display: flex;
                white-space: nowrap;
                overflow: hidden;
              `}
            >
              <RefreshButton onClick={this.handleRefresh} />
              <FeedbackButton
                isWhirl={isWhirl}
                onClick={this.renderFeedback.bind(this, isWhirl)}
              />
            </div>
            {this.renderWebButton()}
          </div>
        )}
        {this.renderMobileButton()}
      </CaptchaWrapper>
    );
  }
}

export default withTheme(connect(mapState, mapDispatch as any)(Captcha) as any);
